import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select'
import countryList from 'react-select-country-list'
import ComboBox from "ui/shared/components/form/ComboBox";

class CountrySelector extends Component {

    static propTypes = {
        input: PropTypes.object,
        className: PropTypes.string,
        placeholder: PropTypes.string,
        onChange: PropTypes.func,
    };

    constructor(props) {
        super(props)

        this.options = countryList().getData().map(country => {
            return {
                ...country,
                id: country.value,
                title: country.label
            }
        })

        this.state = {
            options: this.options,
        }
    }

    changeHandler = value => {
        this.props.onChange(value);
        this.props.input.onChange(value);
    }

    render() {
        return (
            <ComboBox
                disabled={this.props.disabled}
                value={this.props.input.value}
                options={this.state.options}
                onChange={this.changeHandler}
                placeholder={this.props.placeholder}
                className={this.props.className}
            />
        )
    }
}

export default CountrySelector;